import {
    PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
} from "recharts";

const COLORS = {
    success: '#17975a',
    danger: '#cf3a3a',
};

const formatAmount = (value) => `₹${Number(value || 0).toLocaleString('en-IN')}`;
const formatCount = (value) => Number(value || 0).toLocaleString('en-IN');

// Renders the success/fail split (pie) and collected/failed amount (bar)
// for any dashboard that tracks successCount/successAmt/failCount/failAmt.
export default function DashboardCharts({ boxData }) {
    const successCount = Number(boxData.successCount) || 0;
    const failCount = Number(boxData.failCount) || 0;
    const successAmt = Number(boxData.successAmt) || 0;
    const failAmt = Number(boxData.failAmt) || 0;

    const pieData = [
        { name: 'Successful', value: successCount, color: COLORS.success },
        { name: 'Failed', value: failCount, color: COLORS.danger },
    ];
    const barData = [
        { name: 'Collected', amount: successAmt, color: COLORS.success },
        { name: 'Failed', amount: failAmt, color: COLORS.danger },
    ];

    return (
        <div className="row chart-row">
            <div className="col-lg-5 mb-3">
                <div className="chart-card">
                    <h6 className="chart-card__title">Transaction Split</h6>
                    {successCount + failCount > 0 ? (
                        <ResponsiveContainer width="100%" height={260}>
                            <PieChart>
                                <Pie data={pieData} dataKey="value" nameKey="name" innerRadius={60} outerRadius={90} paddingAngle={3}>
                                    {pieData.map((entry) => <Cell key={entry.name} fill={entry.color} />)}
                                </Pie>
                                <Tooltip formatter={formatCount} />
                                <Legend verticalAlign="bottom" height={32} />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <EmptyChart />
                    )}
                </div>
            </div>
            <div className="col-lg-7 mb-3">
                <div className="chart-card">
                    <h6 className="chart-card__title">Amount Overview</h6>
                    {successAmt + failAmt > 0 ? (
                        <ResponsiveContainer width="100%" height={260}>
                            <BarChart data={barData} barSize={56}>
                                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                                <XAxis dataKey="name" tickLine={false} axisLine={false} />
                                <YAxis tickLine={false} axisLine={false} width={70} tickFormatter={formatAmount} />
                                <Tooltip formatter={formatAmount} />
                                <Bar dataKey="amount" radius={[8, 8, 0, 0]}>
                                    {barData.map((entry) => <Cell key={entry.name} fill={entry.color} />)}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    ) : (
                        <EmptyChart />
                    )}
                </div>
            </div>
        </div>
    );
}

const EmptyChart = () => (
    <div className="data-state">
        <i className="fa-solid fa-chart-pie"></i>
        <strong>No data for the selected range</strong>
    </div>
);
